import axios from 'axios';

import { 
	LOGIN_CHECK,
	SET_MANAGED_USER_ENTERPRISE,
	SET_MANAGED_USER,
	SET_USER,
	TOGGLE_MANAGED_USER_ENTERPRISE_PERMISSION
} from './types';

import { URL_ENDPOINT } from '../../../index';

export const setUser = (user) => {
	return {
		type: SET_USER,
		user
	}
}

export const setManagedUserEnterprise = ({ enterprise, userMap }) => {
	return {
		type: SET_MANAGED_USER_ENTERPRISE,
		enterprise,
		userMap
	}
}

export const setManagedUser = ( user ) => {
	return {
		type: SET_MANAGED_USER,
		user
	}
}

export const toggleManagedUserEnterprisePermission = ({ permissionField, userId }) => {
	return {
		type: TOGGLE_MANAGED_USER_ENTERPRISE_PERMISSION,
		permissionField, 
		userId
	}
}

export const checkIfLoggedin = () => {
	return {
		type: LOGIN_CHECK,
		payload: axios({
			withCredentials:true,
			url: `${URL_ENDPOINT}/api/user/admin`,
			method:'get'
		})
	}
}


// WEBPACK FOOTER //
// ./src/components/user/actions/index.js